module.exports = __webpack_public_path__ + "img/csharp.e8460f0d.png";